export const API_BASE_URL = 'https://afrotchop-api-dev.afrimoov.com/api';
